import { ReactNode } from 'react';

// Material-UI
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Divider, Typography, CardProps } from '@mui/material';

// Project Imports
// import Highlighter from './third-party/Highlighter';

// Header style
const headerSX = {
  p: 2.5,
  '& .MuiCardHeader-action': { m: '0px auto', alignSelf: 'center' }
};


// MainCard Component
const MainCard: React.FC<any> = ({
  border = true,
  boxShadow,
  children,
  content = true,
  contentSX = {},
  darkTitle,
  elevation,
  secondary,
  shadow,
  sx = {},
  title,
  codeHighlight,
  ...others
}) => {
  const theme = useTheme();
  boxShadow = theme.palette.mode === 'dark' ? boxShadow || true : boxShadow;

  return (
    <Card
      elevation={elevation || 0}
      {...others}
      sx={{
        border: border ? '1px solid' : 'none',
        borderRadius: 2,
        borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey.A700,
        boxShadow: boxShadow && (!border || theme.palette.mode === 'dark') ? shadow  : 'inherit',
        ':hover': {
          boxShadow: boxShadow ? shadow : 'inherit'
        },
        '& pre': {
          m: 0,
          p: '16px !important',
          fontFamily: theme.typography.fontFamily,
          fontSize: '0.75rem'
        },
        ...sx
      }}
    >
        {/* Card header and action */}
        {!darkTitle && title !== null && title !== undefined && (
        <CardHeader sx={headerSX} titleTypographyProps={{ variant: 'subtitle1' }} title={title} action={secondary} />
      )}
      {darkTitle && title !== null && title !== undefined && (
        <CardHeader sx={headerSX} title={<Typography variant="h3">{title}</Typography>} action={secondary} />
      )}

      {/* Card content */}
      {content && <CardContent sx={contentSX}>{children}</CardContent>}
      {!content && children}


      {/* Card footer - clipboard & highlighter  */}
      {codeHighlight && (
        <>
          <Divider sx={{ borderStyle: 'dashed' }} />
          {/* <Highlighter codeHighlight={codeHighlight} main>
            {children}
          </Highlighter> */}
        </>
      )}
    </Card>
  );
};

export default MainCard;